/** Utah's words for easy.ts: the Utah parts of the plain-words procedures' citations and one step. */
export const EASY_UT = {
  /** Fire: the state workplace-safety rule for an emergency action plan (Utah OSHA, R614-1-4, adopting 29 CFR 1910.38). */
  fireCitation: "Utah Admin. Code R614-1-4 (29 CFR 1910.38, emergency action plan)",
  /** Power or water out: our sources hold no state establishment rule against food work where hands cannot be washed (Utah). */
  noHandwashRuleNote: "no Utah establishment rule in our sources",
  /** Thermometer: our sources give no boiling-point calibration method (Utah); ends the step "Don't use boiling water to check it". */
  noBoilingStepSuffix: " in Utah",
  /** Thermometer: the same fact as a citation note. */
  noBoilingCitationNote: "no boiling-point method in Utah",
} as const;
